document.addEventListener('DOMContentLoaded', function () {
  var minQty = 50;

  // ---------- PRODUCT PAGE LOGIC ----------
  function isKippahProductPage() {
    if (!window.currentProductTitle) return false;
    var title = String(window.currentProductTitle).toLowerCase();
    return title.indexOf('kippah') !== -1;
  }

  function enforceOnProductPage() {
    if (!isKippahProductPage()) return;

    // We use a small interval because some themes update the input
    // via JS without firing input/change events
    function clampAllProductInputs() {
      var qtyInputs = document.querySelectorAll(
        'form[action*="/cart"] input[name="quantity"], input[name="quantity"]'
      );

      qtyInputs.forEach(function (input) {
        // Only touch visible, enabled inputs
        if (input.offsetParent === null || input.disabled) return;

        input.setAttribute('min', minQty);

        var current = parseInt(input.value, 10);
        if (isNaN(current) || current < minQty) {
          input.value = minQty;
        }
      });
    }

    // Run once immediately
    clampAllProductInputs();

    // Then keep enforcing every 200ms on this product page
    setInterval(clampAllProductInputs, 200);
  }

  // ---------- CART + DRAWER LOGIC ----------
  function enforceOnCart(scope) {
    if (!scope) scope = document;

    // Find all quantity inputs that belong to cart line items
    var qtyInputs = scope.querySelectorAll(
      'input[name^="updates"], input[name="quantity"]'
    );

    qtyInputs.forEach(function (input) {
      if (input.dataset.kippahCartBound) return;

      var item = input.closest(
        '.cart-item, .cart-drawer-item, [data-cart-item], [data-cart-item-key], .cart__row, li, tr'
      );
      if (!item) return;

      var titleEl =
        item.querySelector('.cart-item__name') ||
        item.querySelector('.cart-drawer-product-title') ||
        item.querySelector('a[href*="/products/"]');

      if (!titleEl) return;

      var title = (titleEl.textContent || '').trim().toLowerCase();
      if (title.indexOf('kippah') === -1) return;

      input.setAttribute('min', minQty);
      input.dataset.kippahCartBound = 'true';

      function clamp() {
        var current = parseInt(input.value, 10);
        if (isNaN(current) || current < minQty) {
          input.value = minQty;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      input.addEventListener('change', clamp);
      input.addEventListener('input', clamp);

      clamp();
    });
  }

  // ---------- MUTATION OBSERVER FOR AJAX DRAWER ----------
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (!(node instanceof Element)) return;

        if (
          node.matches('.cart-drawer, [id*="CartDrawer"], [data-cart-drawer], [data-cart-items], .cart') ||
          node.querySelector('.cart-drawer, [id*="CartDrawer"], [data-cart-drawer], [data-cart-items], .cart')
        ) {
          enforceOnCart(node);
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // ---------- INITIAL RUN ----------
  enforceOnProductPage();
  enforceOnCart(document);
});
